module.exports = __webpack_public_path__ + "img/Image 12.9735e1f6.png";